import {
  AdminFanAttributeEntity,
  AdminFanAttributeValidator,
  AdminFanAttributesQuery,
  ListEntityV2,
  V2Prefix,
  endpoints,
} from '@seaters/constants';
import { api } from '../axios-instance';

const basePath = `${V2Prefix}/${endpoints.seatersAdmin}/${endpoints.fanAttributes}`;

export const fetchAdminFanAttributes = (
  params: AdminFanAttributesQuery
): Promise<ListEntityV2<AdminFanAttributeEntity>> =>
  api.get(basePath, { params });

export const updateAdminFanAttribute = (
  id: string,
  body: AdminFanAttributeValidator
): Promise<AdminFanAttributeEntity> => api.put(`${basePath}/${id}`, body);

export const validateAdminFanAttribute = (
  id: string
): Promise<AdminFanAttributeEntity> =>
  api.post(`${basePath}/${id}/${endpoints.validate}`);

export const archiveAdminFanAttribute = (
  id: string
): Promise<AdminFanAttributeEntity> => api.delete(`${basePath}/${id}`);
